module.exports = __webpack_public_path__ + "Roboto-Light-webfont.d8472f7b6012706fc028.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/fonts/roboto/Roboto-Light-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Light-webfont.ttf
// module chunks = 2